import { graphql } from "gatsby"
import Layout from "../components/Layout"

import Helmet from "react-helmet"

import ResourceSection from "../components/PageSection"
import styled from "styled-components"
import React from "react"

import text from "styles/text"
import media from "styles/media"
import colors from "styles/colors"

import Hero from "../components/Hero"
import Footer from "components/Footer"

import TwitterIcon from "images/XIcon.webp"
import FBIcon from "images/FacebookIcon.webp"
import LinkedInIcon from "images/LinkedInIcon.webp"

import {
  TwitterShareButton,
  FacebookShareButton,
  LinkedinShareButton,
} from "react-share"

const ResourceSections = ({ content }) => {
  return (
    <div className="page-content">
      {content?.sections?.map((section, i) => (
        <ResourceSection key={i} section={section} />
      ))}
    </div>
  )
}

const Resource = ({ data, pageContext }) => {
  const { wpResource: page } = data
  return (
    <Layout slug={pageContext.slug}>
      <Helmet>
        <title>{page.title}</title>
        <meta name="description" content={page.metaDescription} />
      </Helmet>
      {page?.header?.title && (
        <Hero
          content={page?.header}
          title={page?.title}
          background_image={page?.background_image}
        />
      )}
      {!page?.header?.title && (
        <IntroContainer>
          <TitleContainer>
            <ArticleTitle itemProp="headline">{page.title}</ArticleTitle>
            <SocialDiv>
              <TwitterShareButton
                url={`https://www.printerlogic.com/resources/${page.slug}`}
                title={page.title}
              >
                <SocialIcon alt="social icon" src={TwitterIcon} />
              </TwitterShareButton>

              <FacebookShareButton
                url={`https://www.printerlogic.com/resources/${page.slug}`}
                title={page.title}
              >
                <SocialIcon alt="social icon" src={FBIcon} />
              </FacebookShareButton>

              <LinkedinShareButton
                url={`https://www.printerlogic.com/resources/${page.slug}`}
                title={page.title}
              >
                <SocialIcon alt="social icon" src={LinkedInIcon} />
              </LinkedinShareButton>
            </SocialDiv>
          </TitleContainer>
        </IntroContainer>
      )}
      <ResourceSections content={page.sections} />
    </Layout>
  )
}

export default Resource

const SocialIcon = styled.img`
  width: 2.083vw;
  height: 2.083vw;

  ${media.fullWidth} {
    width: 30px;
    height: 30px;
  }

  ${media.tablet} {
    width: 2.93vw;
    height: 2.93vw;
  }

  ${media.mobile} {
    width: 7.009vw;
    height: 7.009vw;
  }
`
const SocialDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  gap: 1.389vw;
  margin-top: 0.694vw;

  ${media.fullWidth} {
    gap: 20px;
    margin-top: 10px;
  }

  ${media.tablet} {
    gap: 1.953vw;
    margin-top: 0.977vw;
  }

  ${media.mobile} {
    flex-direction: row;
    gap: 4.673vw;
    margin-top: 4.673vw;
    margin-left: unset;
  }
`

const ArticleTitle = styled.h1`
  color: ${colors.black};
  ${text.h1};
  width: 60.417vw;

  ${media.fullWidth} {
    width: 870px;
  }

  ${media.tablet} {
    width: 78.406vw;
  }

  ${media.mobile} {
    width: 87.85vw;
  }
`
const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  justify-content: space-between;

  ${media.fullWidth} {
    width: 1440px;
  }
  ${media.tablet} {
    width: 113.189vw;
  }

  ${media.mobile} {
    flex-direction: column;
    width: unset;
  }
`
const IntroContainer = styled.div`
  display: flex;
  justify-self: center;
  align-self: center;
  width: 79.444vw;
  margin: 5.556vw auto 0 auto;

  ${media.fullWidth} {
    width: 1144px;
    margin: 80px auto 0 auto;
  }

  ${media.tablet} {
    width: 92.188vw;
    margin: 7.813vw auto 0 auto;
  }

  ${media.mobile} {
    width: 87.85vw;
    margin: 18.692vw auto 0 auto;
  }
`

export const resourceQuery = graphql`
  query ResourceQueryById($id: String!) {
    wpResource(id: { eq: $id }) {
      id
      date(formatString: "MMMM DD, YYYY")
      content
      slug
      status
      title
      header {
        textColor
        backgroundDark
        backgroundImage {
          sourceUrl
          altText
        }
        callToActionLink
        callToActionText
        fieldGroupName
        formattedSubtitle
        centeredHero
        image {
          sourceUrl
          altText
        }
        metaDescription
        seoTitle
        subtitle
        eyebrow
        title
        video
        videoThumbnail {
          sourceUrl
          altText
        }
      }
      sections {
        sections {
          ... on WpResource_Sections_Sections_ImageContentBlock {
            fieldGroupName
            backgroundColor
            card
            bodyCopy
            contentSide
            eyebrow
            linkText
            linkUrl
            fieldGroupName
            formId
            formButtonText
            formThankYou
            headline
            textColor
            image {
              sourceUrl
              altText
            }
            imageTop
            bodyCopy
            formId
            linkText
            linkUrl
            spacing
          }
          ... on WpResource_Sections_Sections_Overview {
            fieldGroupName
            header
            columns {
              headline
              customColor
              color
              body
            }
            spacing
          }
          ... on WpResource_Sections_Sections_PillCta {
            fieldGroupName
            headline
            body
            buttonText
            buttonUrl
            backgroundImage {
              sourceUrl
              altText
            }
            spacing
          }
          ... on WpResource_Sections_Sections_CustomerTestimonials {
            fieldGroupName
            backgroundColor
            spacing
            testimonial {
              largeQuote
              name
              rating {
                sourceUrl
                altText
              }
              testimonial
            }
          }
          ... on WpResource_Sections_Sections_OverviewComponents {
            fieldGroupName
            variation
            overviewQuote {
              headshot {
                sourceUrl
                altText
              }
              header
              bodyCopy
              attribution
              image {
                sourceUrl
                altText
              }
              linkText
              linkUrl
            }
            overviewStats {
              header
              statList {
                headline
                color
                customColor
                bodyCopy
              }
              logoHeadline {
                sourceUrl
                altText
              }
              calloutList {
                icon {
                  sourceUrl
                  altText
                }

                bodyCopy
              }
              linkText
              linkUrl
            }
            overviewOverview {
              header
              columns {
                headline
                customColor
                color
                body
              }
            }

            spacing
          }
          ... on WpResource_Sections_Sections_Features {
            eyebrow
            fieldGroupName
            variation
            introBody
            header
            headerSize
            backgroundColor
            textColor
            linkText
            linkUrl
            badges {
              badge {
                sourceUrl
                altText
              }
              badgeName
              badgeCopy
            }
            image {
              sourceUrl
              altText
            }
            imageAlt
            video
            videoThumbnail {
              sourceUrl
              altText
            }
            cards {
              cardImage {
                sourceUrl
                altText
              }
              gradientHeader
              eyebrow
              header
              bodyCopy
              linkText
              linkUrl
            }
            grid {
              icon {
                sourceUrl
                altText
              }
              header
              bodyCopy
            }
            comparison {
              sideOneHeader
              sideOneList {
                listItem
              }
              sideTwoHeader
              sideTwoList {
                listItem
              }
            }
            stats {
              stat
              statCopy
              linkText
              linkUrl
            }
            spacing
          }
          ... on WpResource_Sections_Sections_StatsOverview {
            fieldGroupName
            header

            statList {
              headline
              color
              customColor
              bodyCopy
            }
            logoHeadline {
              sourceUrl
              altText
            }
            calloutList {
              icon {
                sourceUrl
                altText
              }
              bodyCopy
            }
            spacing
          }
          ... on WpResource_Sections_Sections_BoxQuote {
            fieldGroupName
            variation
            headshot {
              sourceUrl
              altText
            }
            header
            bodyCopy
            attribution
            statsHeader
            statList {
              headline
              color
              customColor
              bodyCopy
            }
            logoHeadline {
              sourceUrl
              altText
            }
            calloutList {
              icon {
                sourceUrl
                altText
              }
              bodyCopy
            }
            spacing
          }
          ... on WpResource_Sections_Sections_HighlightedCta {
            backgroundColor
            bodyCopy
            buttonColor
            ctaLink
            ctaText
            fieldGroupName
            textColor
          }
          ... on WpResource_Sections_Sections_ImageCta {
            fieldGroupName
            textColor
            backgroundImages {
              sourceUrl
              altText
            }
            contentSide
            header
            linkText
            linkUrl
            spacing
          }
          ... on WpResource_Sections_Sections_HighlightedCtaCard {
            fieldGroupName
            ctaLink
            ctaText
            textColor
            headline
            body
          }
          ... on WpResource_Sections_Sections_MultiColumnValueProp {
            backgroundColor
            bodyCopy
            buttonColor
            ctaLink
            ctaText
            fieldGroupName
            headline
            textColor
            columns {
              bodyCopy
              fieldGroupName
              headline
              icon {
                sourceUrl
                altText
              }
              link
            }
          }
          ... on WpResource_Sections_Sections_MultiColumnMutliRowValueProp {
            backgroundColor
            bodyCopy
            buttonColor
            ctaLink
            ctaText
            fieldGroupName
            headline
            textColor
            columns {
              bodyCopy
              fieldGroupName
              headline
              icon {
                sourceUrl
                altText
              }
              link
            }
          }
          ... on WpResource_Sections_Sections_TableOfContents {
            backgroundColor
            fieldGroupName
            textColor
            columns {
              bodyCopy
              fieldGroupName
              headline
              link
            }
          }
          ... on WpResource_Sections_Sections_OverviewComponents {
            fieldGroupName
            variation
            overviewQuote {
              headshot {
                sourceUrl
                altText
              }
              header
              bodyCopy
              attribution
              image {
                sourceUrl
                altText
              }
              linkText
              linkUrl
            }
            overviewStats {
              header
              statList {
                headline
                color
                customColor
                bodyCopy
              }
              logoHeadline {
                sourceUrl
                altText
              }
              calloutList {
                icon {
                  sourceUrl
                  altText
                }

                bodyCopy
              }
              linkText
              linkUrl
            }
            overviewOverview {
              header
              columns {
                headline
                customColor
                color
                body
              }
            }

            spacing
          }
          ... on WpResource_Sections_Sections_PartnerStatic {
            backgroundColor
            bodyCopy
            buttonColor
            ctaLink
            ctaText
            fieldGroupName
            headline
            textColor
            columns {
              bodyCopy
              fieldGroupName
              headline
              icon {
                sourceUrl
                altText
              }
              link
            }
          }
          ... on WpResource_Sections_Sections_ThreeGrid {
            backgroundColor
            bodyCopy
            buttonColor
            eyebrow
            ctaLink
            ctaText
            fieldGroupName
            headline
            textColor
            sectionHeader
            columns {
              link
              headline
              fieldGroupName
              bodyCopy
              icon {
                sourceUrl
                altText
              }
            }
          }
          ... on WpResource_Sections_Sections_FlexibleText {
            backgroundColor
            bodyCopy
            fieldGroupName
            textColor
            spacing
          }
          ... on WpResource_Sections_Sections_ResourceCta {
            fieldGroupName
            body
            subCopy
            spacing
          }
          ... on WpResource_Sections_Sections_QaComponent {
            fieldGroupName
            header
            content {
              answer
              question
            }
            spacing
          }
          ... on WpResource_Sections_Sections_SocialHandles {
            fieldGroupName
            socialHandles {
              socialIcon {
                sourceUrl
                altText
              }
              linkText
              linkUrl
            }
            spacing
          }
          ... on WpResource_Sections_Sections_FaqList {
            fieldGroupName
            introHeader
            introBody
            faqColumn {
              columnHeader
              listItems {
                listItemCopy
              }
            }
            spacing
          }
          ... on WpResource_Sections_Sections_GuidedContent {
            fieldGroupName
            sectionId
            header
            headerColor
            introBody
            variation
            section {
              icon {
                sourceUrl
                altText
              }
              headline
              body
            }
            lineSeperator
            bottomCopy
            spacing
          }
          ... on WpResource_Sections_Sections_DataCard {
            backgroundColor
            fieldGroupName
            headline
            source
            textColor
            columns {
              bodyCopy
              fieldGroupName
              stat
            }
          }
          ... on WpResource_Sections_Sections_StatGrid {
            backgroundColor
            fieldGroupName
            headingCopy
            textColor
            columns {
              bodyCopy
              fieldGroupName
              headline
              icon {
                sourceUrl
                altText
              }
            }
          }
          ... on WpResource_Sections_Sections_Tabs {
            backgroundColor
            bodyCopy
            fieldGroupName
            headline
            textColor
            columns {
              bodyCopy
              fieldGroupName
              title
              bodyImage {
                sourceUrl
                altText
              }
            }
          }
          ... on WpResource_Sections_Sections_CardComponent {
            backgroundColor
            bodyCopy
            fieldGroupName
            eyebrow
            headline
            textColor
            columns {
              cardEyebrow
              bodyCopy
              fieldGroupName
              cardEyebrow
              headline
              link
              icon {
                sourceUrl
                altText
              }
            }
          }
          ... on WpResource_Sections_Sections_AccordionSection {
            backgroundColor
            bodyCopy
            fieldGroupName
            headline
            textColor
            accordion {
              bodyCopy
              fieldGroupName
              headline
              image {
                sourceUrl
                altText
              }
            }
          }
          ... on WpResource_Sections_Sections_TestimonialCarousel {
            fieldGroupName
            mode
            quotes {
              quote
              author
              position
              location
            }
            linkText
            linkSrc
            spacing
          }
          ... on WpResource_Sections_Sections_ByTheNumbers {
            backgroundColor
            fieldGroupName
            headlineNumber
            eyebrow
            body
            textColor
            columns {
              description
              fieldGroupName
              indicator
              number
            }
          }
          ... on WpResource_Sections_Sections_TwoColumnList {
            fieldGroupName
            header
            headerSize
            starList
            iconList
            introCopy
            icons {
              sourceUrl
            }
            list {
              listItemHeader
              listItemCopy
            }
            spacing
          }
          ... on WpResource_Sections_Sections_ResourceCta {
            fieldGroupName
            body
            subCopy
            spacing
          }
          ... on WpResource_Sections_Sections_SimpleCenteredContent {
            fieldGroupName
            backgroundColor
            textColor
            eyebrowCopy
            headline
            bodyCopy
            image {
              sourceUrl
              altText
            }
            mobileImage {
              sourceUrl
              altText
            }
            formId
            linkText
            linkUrl
            button
            video
            videoThumbnail {
              sourceUrl
              altText
            }
            spacing
          }
          ... on WpResource_Sections_Sections_BottomCta {
            fieldGroupName
            backgroundColor
            textColor
            fwBackgroundImage {
              sourceUrl
              altText
            }
            headline
            bodyCopy
            buttonText
            buttonLink
            spacing
          }
          ... on WpResource_Sections_Sections_Logos {
            fieldGroupName
            backgroundColor
            cardColor
            spacing
            mainSide
            mainLogo {
              sourceUrl
              altText
            }
            mainHeadline
            mainBody
            mainLinkText
            mainLink
            logosCategory
            logos {
              sourceUrl
              altText
            }
          }
          ... on WpResource_Sections_Sections_G2Ads {
            fieldGroupName
          }
          ... on WpResource_Sections_Sections_G2Banner {
            fieldGroupName
            spacing
          }
          ... on WpResource_Sections_Sections_LogoCube {
            fieldGroupName
            header
            logos {
              alt
              image {
                sourceUrl
                altText
              }
            }
          }
          ... on WpResource_Sections_Sections_ChromeLogos {
            fieldGroupName
          }
          ... on WpResource_Sections_Sections_StyledList {
            fieldGroupName
            header
            kicker
            pointContent {
              content
            }
            points
          }
          ... on WpResource_Sections_Sections_GridComponent {
            fieldGroupName
            sectionHeader
            headerSmall
            header
            spacing
            grid {
              icon {
                sourceUrl
                altText
              }
              gridHeadline
              body
            }
            bottomCopy
          }
          ... on WpResource_Sections_Sections_InfoBox {
            fieldGroupName
            introHeader
            infoBlocks {
              stat
              bodyCopy
              source
            }
            spacing
          }
          ... on WpResource_Sections_Sections_SimpleVideo {
            backgroundColor
            bodyCopy
            fieldGroupName
            formId
            textColor
            video
            image {
              sourceUrl
              altText
            }
          }
          ... on WpResource_Sections_Sections_SectionHeading {
            backgroundColor
            bodyCopy
            fieldGroupName
            textColor
          }
          ... on WpResource_Sections_Sections_FlexibleText {
            backgroundColor
            bodyCopy
            fieldGroupName
            textColor
          }
          ... on WpResource_Sections_Sections_AnimatedQuote {
            fieldGroupName
            headline
            linkText
            linkUrl
            quotes {
              quote
              person
            }
          }
          ... on WpResource_Sections_Sections_Testimonial {
            fieldGroupName
            quoteBody
            name
            asideImage
            image {
              sourceUrl
              altText
            }
            companyAndTitle
            location
            mode
            largeQuote
            ctaText
            ctaLink
          }
          ... on WpResource_Sections_Sections_AsideTestimonial {
            fieldGroupName
            quoteBody
            personQuoted
            image {
              sourceUrl
              altText
            }
            callout
            quoteEyebrow
            headline
            body
            linkText
            linkCta
            quoteCardBackground
            backgroundColor
          }
          ... on WpResource_Sections_Sections_VideoHighlights {
            backgroundColor
            featuredVideoId
            fieldGroupName
            textColor
            featuredVideoThumbnail {
              sourceUrl
              altText
            }
            otherHighlightVideos {
              videoId
              fieldGroupName
              videoTitle
              videoThumbnail {
                sourceUrl
                altText
              }
            }
          }
          ... on WpResource_Sections_Sections_PinScroll {
            fieldGroupName
            items {
              bodyContent
              bodyHeadline
              ctaLink
              ctaText
              points {
                text
              }
            }
            topics {
              headline
            }
          }
          ... on WpResource_Sections_Sections_SplitForm {
            backgroundColor
            body
            fieldGroupName
            formId
            header
          }
        }
      }
    }
  }
`
